import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';
import { type ExportTemplateAnalysis, type ExportFillWarning } from '../../../types/exportTemplate';

/**
 * 指定フォーマット出力（#3070）の Functions 呼び出し。
 *
 * 流し込みに使う xlsx-template が Node の path/fs に依存しており
 * ブラウザで動かせないため、解析・生成はサーバ側で行う。
 */

interface AnalyzeRequest {
  /** Storage 上のフォーマットのパス */
  file_path?: string;
  /** Base64 の .xlsx（アップロード前に解析するとき） */
  file_content?: string;
}

interface GenerateRequest {
  template_id: string;
  result_id: string;
}

interface GenerateResponse {
  /** Base64 の .xlsx */
  file_content: string;
  file_name: string;
  warnings: ExportFillWarning[];
}

/** フォーマットを解析して、シート一覧と参照フィールドコードを得る */
export const analyzeExportTemplate = async (
  request: AnalyzeRequest,
): Promise<ExportTemplateAnalysis> => {
  const callable = httpsCallable<AnalyzeRequest, ExportTemplateAnalysis>(
    functions,
    'analyzeExportTemplate',
  );
  const result = await callable(request);
  return result.data;
};

/** OCR 結果をフォーマットに流し込んで .xlsx を生成する */
export const generateExportTemplateFile = async (
  request: GenerateRequest,
): Promise<GenerateResponse> => {
  const callable = httpsCallable<GenerateRequest, GenerateResponse>(
    functions,
    'generateExportTemplateFile',
  );
  const result = await callable(request);
  return result.data;
};
